import { render, staticRenderFns } from "./DonateLinks.vue?vue&type=template&id=ba971550&scoped=true"
import script from "./DonateLinks.vue?vue&type=script&lang=js"
export * from "./DonateLinks.vue?vue&type=script&lang=js"
import style0 from "./DonateLinks.vue?vue&type=style&index=0&id=ba971550&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba971550",
  null
  
)

export default component.exports